import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './layout/Index';
import * as serviceWorker from './serviceWorker';
import { ConfigProvider } from 'antd';
import { locales } from 'antd/dist/antd-with-locales';
import 'moment/locale/es';

locales.da = {
    "locale": "es-PE",
    "Pagination": {
        "items_per_page": "/ page",
        "jump_to": "Goto",
        "page": "",
        "prev_page": "Previous Page",
        "next_page": "Next Page",
        "prev_5": "Previous 5 Pages",
        "next_5": "Next 5 Pages",
        "prev_3": "Previous 3 Pages",
        "next_3": "Next 3 Pages"
    },
    "DatePicker": {
        "lang": {
            "placeholder": "Select date",
            "rangePlaceholder": [
                "Start date",
                "End date"
            ],
            "today": "Hoy",
            "now": "Now",
            "backToToday": "Back to today",
            "ok": "Ok",
            "clear": "Clear",
            "month": "Month",
            "year": "Year",
            "timeSelect": "Select time",
            "dateSelect": "Select date",
            "monthSelect": "Choose a month",
            "yearSelect": "Choose a year",
            "decadeSelect": "Choose a decade",
            "yearFormat": "YYYY",
            "dateFormat": "D/M/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "D/M/YYYY HH:mm:ss",
            "monthBeforeYear": true,
            "previousMonth": "Previous month (PageUp)",
            "nextMonth": "Next month (PageDown)",
            "previousYear": "Last year (Control + left)",
            "nextYear": "Next year (Control + right)",
            "previousDecade": "Last decade",
            "nextDecade": "Next decade",
            "previousCentury": "Last century",
            "nextCentury": "Next century"
        },
        "timePickerLocale": {
            "placeholder": "Select time"
        }
    },
    "TimePicker": {
        "placeholder": "Select time"
    },
    "Calendar": {
        "lang": {
            "placeholder": "Select date",
            "rangePlaceholder": [
                "Start date",
                "End date"
            ],
            "today": "Today",
            "now": "Now",
            "backToToday": "Back to today",
            "ok": "Ok",
            "clear": "Clear",
            "month": "Month",
            "year": "Year",
            "timeSelect": "Select time",
            "dateSelect": "Select date",
            "monthSelect": "Choose a month",
            "yearSelect": "Choose a year",
            "decadeSelect": "Choose a decade",
            "yearFormat": "YYYY",
            "dateFormat": "D/M/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "D/M/YYYY HH:mm:ss",
            "monthBeforeYear": true,
            "previousMonth": "Previous month (PageUp)",
            "nextMonth": "Next month (PageDown)",
            "previousYear": "Last year (Control + left)",
            "nextYear": "Next year (Control + right)",
            "previousDecade": "Last decade",
            "nextDecade": "Next decade",
            "previousCentury": "Last century",
            "nextCentury": "Next century"
        },
        "timePickerLocale": {
            "placeholder": "Select time"
        }
    },
    "Table": {
        "filterTitle": "Filter menu",
        "filterConfirm": "OK",
        "filterReset": "Reset",
        "emptyText": "No data",
        "selectAll": "Select current page",
        "selectInvert": "Invert current page"
    },
    "Modal": {
        "okText": "OK",
        "cancelText": "Cancel",
        "justOkText": "OK"
    },
    "Popconfirm": {
        "okText": "OK",
        "cancelText": "Cancel"
    },
    "Transfer": {
        "notFoundContent": "Not Found",
        "searchPlaceholder": "Search here",
        "itemUnit": "item",
        "itemsUnit": "items"
    },
    "Select": {
        "notFoundContent": "Not Found"
    },
    "Upload": {
        "uploading": "Uploading...",
        "removeFile": "Remove file",
        "uploadError": "Upload error",
        "previewFile": "Preview file"
    }
};

ReactDOM.render(<ConfigProvider locale={locales.da}><App /></ConfigProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
